import { render, staticRenderFns } from "./canceled.vue?vue&type=template&id=31bc8b21&"
import script from "./canceled.vue?vue&type=script&lang=ts&"
export * from "./canceled.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports